import React, { useEffect, useState, useMemo} from 'react';
import { CircularProgress } from "@mui/material";
import PostSPCard from './PostSPCard';

const Rascunhos = (params) => {

  const baseUrl = process.env.REACT_APP_API_URL || window.location.origin;
  const url = `${baseUrl}/content/rascunhos`;
  const requestHeaders = useMemo(() => {
    const headers = new Headers();
    headers.append("X-Frontend-Client", "react-app");
    return headers;
  }, []);
  const [pages, setPages] = useState([]);
  const [isLoading, setLoading] = useState(false);

      
  useEffect(() => {
  const fetchData = () => {
    fetch(url, {
      method: 'GET',
      headers: requestHeaders
      })
      .then((response) => response.json())
      .then((result) => {
        setPages(result);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
    };
    fetchData();
  }, [url, requestHeaders]);

  if (isLoading) {
    return <CircularProgress className="loading" />;
  }


  return (
    <div>
      <ul className='cards'>
        {pages.map(page =>  
          <li className="cards_item"  key={page.id}>
            <PostSPCard postObject={page} location="lista"/>
          </li>
          )}
      </ul>
    </div>
  );
};

export default Rascunhos;

